
(function () {
  if (window.location.pathname !== '/') return;
  if (window.Shopify && window.Shopify.designMode) return; 
  var BLOCK = [];
  var DEFER = [
    'googletagmanager.com',
    'google-analytics.com',
    'doubleclick.net',
    'fbevents.js',
    'connect.facebook.net',
    'clarity.ms',
    '/wpm/',
    'nice-team.net',
    '/xsell',
    'windowshop',
    'cross_sell',
    'warnify',
    'hextom',
    'roseperl',
    'preview-bar',
    'storefront-banner'
  ];

  var queue = [];    // neutralized elements awaiting release (element re-injection)
  var urlQueue = []; // bare URLs captured from static tags awaiting release
  var released = false;
  var _ce = document.createElement.bind(document);

  function matches(list, src) {
    for (var i = 0; i < list.length; i++) {
      if ((src + '').indexOf(list[i]) !== -1) return true;
    }
    return false;
  }

  // Neutralize an element so the browser never fetches/executes it; remember the URL.
  function neutralize(el, v, _sa) {
    _sa('type', 'text/plain');
    _sa('data-z9d', v);
    if (matches(DEFER, v) && queue.indexOf(el) === -1) queue.push(el);
  }

  document.createElement = function (tag) {
    var el = _ce(tag);
    if (released || (tag + '').toLowerCase() !== 'script') return el;
    var _sa = el.setAttribute.bind(el);

    // Hook BOTH ways a loader can set the URL:
    // 1) property assignment (s.src = url) — how Trekkie injects gtag and /wpm/
    try {
      Object.defineProperty(el, 'src', {
        configurable: true,
        get: function () { return el.getAttribute('data-z9d') || el.getAttribute('src') || ''; },
        set: function (v) {
          if (matches(BLOCK, v) || matches(DEFER, v)) { neutralize(el, v, _sa); }
          else { _sa('src', v); }
        }
      });
    } catch (_) {}

    // 2) setAttribute('src', url)
    el.setAttribute = function (n, v) {
      if ((n + '').toLowerCase() === 'src' && (matches(BLOCK, v) || matches(DEFER, v))) {
        neutralize(el, v, _sa);
        return;
      }
      _sa(n, v);
    };
    return el;
  };

  function release() {
    if (released) return;
    released = true;
    document.createElement = _ce;
    for (var i = 0; i < queue.length; i++) {
      var orig = queue[i];
      var src = orig.getAttribute('data-z9d');
      if (!src) continue;
      var s = _ce('script');
      for (var j = 0; j < orig.attributes.length; j++) {
        var a = orig.attributes[j];
        if (a.name !== 'type' && a.name !== 'data-z9d' && a.name !== 'src') s.setAttribute(a.name, a.value);
      }
      s.setAttribute('data-z9r', '1'); // marks re-injected scripts so the observer skips them
      s.async = true;
      s.src = src;
      document.head.appendChild(s);
      if (orig.parentNode) orig.parentNode.removeChild(orig);
    }
    queue = [];
    for (var k = 0; k < urlQueue.length; k++) {
      var t = _ce('script');
      t.setAttribute('data-z9r', '1');
      t.async = true;
      t.src = urlQueue[k];
      document.head.appendChild(t);
    }
    urlQueue = [];
  }

  // Any user signal releases the deferred scripts; mouse-move counts, so analytics
  // start almost immediately for real desktop users. The 30s failsafe covers fully
  // passive sessions and sits well outside any lab measurement window.
  window.addEventListener('scroll', release, { once: true, passive: true });
  document.addEventListener('pointerdown', release, { once: true });
  document.addEventListener('pointermove', release, { once: true, passive: true });
  document.addEventListener('touchstart', release, { once: true, passive: true });
  document.addEventListener('keydown', release, { once: true });
  setTimeout(release, 30000);

  // Static script tags rendered directly into content_for_header HTML (e.g. the Google
  // channel's gtag tag) never go through createElement. Catch them as they're parsed:
  // BLOCK → drop; DEFER → capture the URL and re-inject it on release.
  if (window.MutationObserver) {
    var mo = new MutationObserver(function (muts) {
      for (var a = 0; a < muts.length; a++) {
        var added = muts[a].addedNodes;
        for (var b = 0; b < added.length; b++) {
          var node = added[b];
          if (!node || node.tagName !== 'SCRIPT') continue;
          if (node.getAttribute && node.getAttribute('data-z9r')) continue; // re-injected by release()
          var s = (node.getAttribute && node.getAttribute('src')) || node.src || '';
          if (!s) continue;
          if (matches(BLOCK, s)) {
            node.type = 'text/plain';
            if (node.parentNode) node.parentNode.removeChild(node);
          } else if (!released && matches(DEFER, s)) {
            node.type = 'text/plain';
            if (node.parentNode) node.parentNode.removeChild(node);
            if (urlQueue.indexOf(s) === -1) urlQueue.push(s);
          }
        }
      }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    // Keep observing until shortly after load so late static injections are caught too.
    window.addEventListener('load', function () { setTimeout(function () { mo.disconnect(); }, 3000); });
  }
})();
